import { observable } from 'mobx'
import { Model, type ModelProps } from '@/infra/model'
import { Id } from '@/infra/id'
import { unixEpoch } from '@/utils/date-util'
import { PersonalInfo } from './PersonalInfo'

export type DependentProfileVersionProps = ModelProps<DependentProfileVersion>

/**
 * A version of a dependent profile.
 */
export class DependentProfileVersion extends Model<DependentProfileVersion> {
  id = Id.none

  @observable accessor version = 0
  @observable accessor workspaceId = Id.none
  @observable accessor ownerUserId = Id.none
  @observable accessor relationship = ''
  @observable accessor createdAt = unixEpoch()
  @observable accessor updatedAt = unixEpoch()
  @observable.shallow accessor personalInfo: PersonalInfo = PersonalInfo.empty
}

/**
 * Formats an ID string for the backing collection of dependent
 * profile versions.
 */
export const DependentProfileVersionId = {
  from: (id: Id, version: number | undefined): string => {
    if (version === undefined) {
      throw new TypeError('Profile version ID cannot be undefined')
    }

    return `${Id.assert(id)}@v${version}`
  },
}
